module.exports = __webpack_public_path__ + "img/rg-target-vessel-safe-default.f46d334e.svg";